import { render, staticRenderFns } from "./VantShareSavePop.vue?vue&type=template&id=7bfbce09&"
import script from "./VantShareSavePop.vue?vue&type=script&lang=js&"
export * from "./VantShareSavePop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports